import { SalesChannel } from '../../enum';
import { ApiError } from '../../interface/dto/ApiError';
import TariffResponse from '../../interface/TariffResponse';
import { ActionType } from './enum';
import { StateProps } from './interface';

export const initStore = (payload: Partial<StateProps>) => ({
    type: ActionType.INIT_STORE,
    payload,
} as const);

export const setSalesChannel = (payload: SalesChannel = SalesChannel.CONSUMER) => ({
    type: ActionType.SET_SALESCHANNEL,
    payload,
} as const);

export const getTariffSuccess = (payload: TariffResponse) => ({
    type: ActionType.GET_TARIFF_SUCCESS,
    payload,
} as const);

export const setError = (error: ApiError | Error) => ({
    type: ActionType.SET_ERROR,
    error,
} as const);

export const selectOption = (subscriptionId?: string, hardwareId?: string) => ({
    type: ActionType.SELECT_OPTION,
    subscriptionId,
    hardwareId,
} as const);

export type Actions = ReturnType<typeof initStore>
    | ReturnType<typeof setSalesChannel>
    | ReturnType<typeof getTariffSuccess>
    | ReturnType<typeof setError>
    | ReturnType<typeof selectOption>;
